import React from "react";
import HomeBlueBackground from "../../img/HomeBlueBackground.png";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import useTranslation from "../../hooks/useTranslation";
import { useLocation } from "react-router-dom";

const useStyles = (theme, isMobile) => ({
  hero: {
    width: "100%",
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    flexDirection: "column",
    color: "#ffffff",
    minHeight: { xs: "533px", md: "650px", lg: "680px", xl: "700px" },
    borderRadius: {
      xs: "0",
      sm: "0px 0px 20px 20px",
      md: "0px 0px 30px 30px",
      lg: "0px 0px 40px 40px",
      xl: "0px 0px 75px 75px",
    },
    background: `linear-gradient(to bottom, #272648 0%, #110e1b 0%, #252241 95%);`,
    backgroundImage: `url(${HomeBlueBackground})`,
    backgroundSize: "cover",
    textAlign: "center",
    padding: "0 0 120px",
  },
  intro: {
    width: { xs: "100%", md: "90%", xl: "1455px" },
    padding: { xs: "0 0 75px" },
    marginTop: { xs: "-70px" },
    borderRadius: { xs: "47px" },
    backgroundColor: theme.palette.white.main,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    position: "relative",
    zIndex: "10",
  },
  titleContainer: {
    marginTop: { sm: "72px" },
    display: { md: "flex" },
    justifyContent: { md: "center" },
    alignItems: { md: "center" },
  },
  line: {
    width: "25px",
    border: `1px solid ${theme.palette.red.main}`,
    marginRight: "8px",
    backgroundColor: theme.palette.red.main,
  },
  typography: {
    hero: {
      fontFamily: theme.typography.montserrat.light,
      fontSize: { xs: "25px", xl: "50px" },
      width: { xs: "270px", sm: "80%", xl: "1200px", lg: "700px" },
      marginTop: { xs: "89px" },
    },
    heroTitle: {
      fontFamily: theme.typography.montserrat.light,
      fontSize: { xl: "60px", md: "50px", sm: "36px", xs: "40px" },
      width: { xs: "270px", sm: "80%", xl: "1200px", lg: "700px" },
      marginTop: { xs: "89px" },
    },

    section: {
      fontSize: isMobile ? "14px" : "16px",
      fontWeight: "bold",
      letterSpacing: "2px",
      marginTop: { xs: "81px", md: "0" },
      color: theme.palette.red.main,
    },
    intro: {
      fontFamily: theme.typography.montserrat.regular,
      fontSize: { xs: "18px", xl: "22px" },
      color: theme.palette.blue.main,
      marginTop: { xs: "37px" },
      width: { xs: "270px", md: "75%" },
    },
    introTitle: {
      fontFamily: theme.typography.montserrat.regular,
      fontSize: { xs: "30px", xl: "35px" },
      color: theme.palette.blue.main,
      marginTop: { xs: "37px" },
      width: { xs: "270px", md: "75%" },
    },
  },
});

const HeroSection = () => {
  const isMobile = useMediaQuery("(max-width:899px)");
  const path = useLocation().pathname;
  const component = "HeroSection";
  const {
    heroTitle,
    hero,
    section,
    introTitle,
    intro,
    heroextDesktop,
    introAuthor,
  } = useTranslation(path, component);
  const theme = useTheme();
  const classes = useStyles(theme, isMobile);

  return isMobile ? (
    <>
      <Box sx={classes.hero}>
        <Typography sx={classes.typography.heroTitle}>
          <b>{heroTitle}</b>
        </Typography>
        <Typography sx={classes.typography.hero}>
          {hero[0]}
          <b> {hero[1]} </b>
          {hero[2]}
          <br />
          {hero[3]}
          <b>{hero[4]}</b>
          {hero[5]}
        </Typography>
      </Box>
      <Box sx={classes.intro}>
        <Typography sx={classes.typography.section}>{section}</Typography>
        <Typography sx={classes.typography.introTitle}>
          <b>{introTitle}</b>
        </Typography>
        <Typography sx={classes.typography.intro}>
          {intro.map((text, i) => (i % 2 ? <b>text</b> : text))}
          <br />
          <br />
          <b>{introAuthor}</b>
        </Typography>
      </Box>
    </>
  ) : (
    <>
      <Box sx={classes.hero}>
        <Typography sx={classes.typography.heroTitle}>
          <b>{heroTitle}</b>
        </Typography>
        <Typography sx={classes.typography.hero}>
          {hero[0]}
          <b> {hero[1]} </b>
          {hero[2]}
          {hero[3]}
          <b>{hero[4]}</b>
          {hero[5]}
        </Typography>
        <Typography sx={classes.typography.hero}>{heroextDesktop}</Typography>
      </Box>
      <Box sx={classes.intro}>
        <Box sx={classes.titleContainer}>
          <div style={classes.line}></div>
          <Typography sx={classes.typography.section}>{section}</Typography>
        </Box>
        <Typography sx={classes.typography.introTitle}>
          <b>{introTitle}</b>
        </Typography>
        <Typography sx={classes.typography.intro}>
          {intro.map((text, i) => (i % 2 ? <b>{text}</b> : text))}
          <br />
          <br />
          <b>{introAuthor}</b>
        </Typography>
      </Box>
    </>
  );
};

export default HeroSection;
